import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import MainLayout from "./MainLayout";

import logoAgilauto from "../../images/agilauto_assets/logo.svg";
import logoEma from "../../images/ema_assets/logo.svg";
import logoKeematic from "../../images/logo.svg";

function AuthLayout({ children, modules, ...props }) {
  const [logo, setLogo] = useState(null);
  const [style, setStyle] = useState(null);
  const name = modules.organisation_name;

  useEffect(() => {
    if (modules && modules.organisation_name) {
      chooseBrandingAuth(modules.organisation_name);
    }
  }, []);

  const chooseBrandingAuth = (name) => {
    switch (name) {
      case "Keematic":
        setLogo(logoKeematic);
        setStyle(stylesKeematic);
        break;
      case "Ema":
        setLogo(logoEma);
        setStyle(stylesEma);
        break;
      case "Agilauto Partage":
        setLogo(logoAgilauto);
        setStyle(stylesAgilauto);
        break;
      default:
        setLogo(logoKeematic);
        setStyle(stylesKeematic);
    }
  };

  const makeLink = () => {
    if (!modules.organisation_name) {
      return (
        <a
          style={style && style.logo}
          target="_blank"
          rel="noreferrer"
          href={`http://www.${name.toLowerCase()}.com`}
        />
      );
    }

    if (modules.organisation_name === "Ema") {
      return (
        <a
          style={style && style.logo}
          target="_blank"
          rel="noreferrer"
          href="https://ema-mobilite.fr/"
        />
      );
    }

    if (modules.organisation_name === "Agilauto Partage") {
      return (
        <a
          style={style && style.logo}
          target="_blank"
          rel="noreferrer"
          href="https://agilautopartage-ca.fr/"
        />
      );
    }
  };

  const commonStyles = {
    container: {
      position: "relative",
      height: "100%",
      minHeight: "100%",
      backgroundColor: "#4158D0",
    },
    logo: {
      display: "block",
      position: "absolute",
      bottom: 0,
      backgroundColor: "transparent",
      backgroundPosition: "center center",
    },
  };

  const stylesKeematic = {
    container: {
      ...commonStyles.container,
      backgroundImage: "linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)",
    },

    logo: {
      ...commonStyles.logo,
      left: 0,
      height: "64px",
      width: "64px",
      backgroundImage: `url(${logo})`,
      backgroundSize: "auto 35px",
    },
  };

  const stylesEma = {
    container: {
      ...commonStyles.container,
      backgroundImage: "linear-gradient(43deg, rgba(84,189,189,1) 25%, rgba(255,205,0,1) 100%)",
    },

    logo: {
      ...commonStyles.logo,
      left: 10,
      height: "48px",
      width: "48px",
      backgroundImage: `url(${logoEma})`,
    },
  };

  const stylesAgilauto = {
    container: {
      ...commonStyles.container,
      backgroundImage:
        "linear-gradient(43deg,rgba(154, 154, 154, 1) 0%,rgba(111, 158, 159, 1) 15%,rgba(0, 78, 57, 1) 55%,rgba(0, 149, 151, 1) 85%,rgba(71, 237, 30, 1) 100%)",
    },

    logo: {
      ...commonStyles.logo,
      left: -100,
      height: "128px",
      width: "512px",
      backgroundImage: `url(${logoAgilauto})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
    },
  };

  return (
    <MainLayout {...props}>
      <div style={style && style.container}>
        {makeLink()}
        {children}
        <p
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            textAlign: "center",
            color: "#FFF",
          }}
        >
          {modules.organisation_name !== "Keematic"
            ? `© ${dayjs().format("YYYY")}.`
            : `© 2018 - ${dayjs().format("YYYY")}.`} Tous droits réservés à {modules.organisation_name} SAS |{" "}
          <a
            style={{ color: "#FFF" }}
            href="https://www.keematic.com/rgpd"
            target="_blank"
            rel="noreferrer"
          >
            Politique de gestion des données personnelles
          </a>
        </p>
      </div>
    </MainLayout>
  );
}

function mapStateToProps(state) {
  return {
    modules: state.modules.modules,
  };
}

export default connect(mapStateToProps)(AuthLayout);
